var map = {
	"./partner1.png": 90997,
	"./partner10.png": 77873,
	"./partner11.png": 84008,
	"./partner12.png": 20867,
	"./partner2.png": 5246,
	"./partner3.png": 76583,
	"./partner4.png": 1416,
	"./partner5.png": 41361,
	"./partner6.png": 16698,
	"./partner7.png": 38275,
	"./partner8.png": 94404,
	"./partner9.png": 42938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93245;